export class APIConstants {
  static readonly DIFY_API_KEY_BIO = 'app-4H3iosVERX4UnR0hMJtKRI64';
  
  static get CURRENT_ENVIRONMENT(): string {
    // Check if we're on production domain
    const isProductionDomain = window.location.hostname.includes('prod.goodmates.org') || 
                              window.location.hostname === 'goodmates.org';
    return isProductionDomain ? 'prod' : 'test';
  }
}